import { LineChart } from '@tamagui/lucide-icons';
import { PortfolioHistory } from '@unistocks/features/dashboard/components/dashboard-data/portfolio-history/portfolio-history';
import { queryFilter } from '@unistocks/features/dashboard/components/dashboard-data/portfolio-history/query-filter';
import {
  PortfolioHistorySettings,
  portfolioHistorySchemaFactory
} from '@unistocks/features/dashboard/components/dashboard-data/portfolio-history/settings';
import { DashboardItemDescriptor } from '@unistocks/features/dashboard/dashboard-item-descriptor';
import { DateConstant } from '@unistocks/proxy/axios-client';

export const dashboardItemDescriptor: DashboardItemDescriptor = {
  component: PortfolioHistory,
  settingsSteps: [PortfolioHistorySettings],
  schemaFactory: portfolioHistorySchemaFactory,
  defaults: setValue => {
    setValue('period', DateConstant.ThisYear);
  },
  queryFilter: queryFilter,
  icon: LineChart
};
